import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import FormControlLabel from '@mui/material/FormControlLabel';
import Moment from 'react-moment';

// form
import { useForm, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Grid, Paper, Typography, Alert, Checkbox, MenuItem, Button, Select, SelectChangeEvent, Tooltip } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../components/settings';
import FormProvider, { RHFAutocomplete, RHFCheckbox, RHFCheckboxWithLabel, RHFFileUploadField, RHFSelect } from '../../components/hook-form';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAxiosPrivateMultiPart from '../../hooks/useAxiosPrivateMultiPart';
import { onPortalAddFood, onPortalUpdateFood, onPortalUpdateFoodDate, onPortalUpdateFoodV2, onPortalAddFoodV2 } from '../../APIs/foods';
import { getPortalFoodTypes } from '../../APIs/food-type';
import { getPortalFoodMeasures } from '../../APIs/food-measure';
import { getPortalDataSources, getPortalAminoAcidDataSources } from '../../APIs/data-source';
import { getPortalBrands } from '../../APIs/brand';
import { GridPaper, GridPaperSelect, GridPaperSwitch, GridPaperDate, GridPaperonChange, GridPaperTextArea } from '../../components/custom-grid-input';
import { StyledIcon } from '../../components/nav-section/vertical/styles';
import SvgColor from '../../components/svg-color';


const classes = {
    root: {
        flexGrow: 1
    },
    paper: {
        padding: 5,
        textAlign: "center",
        color: "inherit"
    },
    aminoAcidIdBtn: {
        flexGrow: 1,
        paddingBottom: '8px',
        paddingLeft: '5px'
    },
    aminoAcidDropdown: {
        width: '15%'
    }
};

/* eslint-disable react/prop-types */
const FoodView = ({ onChangeUser, item, onHandleClose, acids = [], readOnly = true, setSelectedFood, disabled = true, fileList = [] }) => {
    const _readonly = item ?? false;
    const validateMaxLength = true;
    const masterAminoAcids = acids.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();
    const axiosPrivateMultipart = useAxiosPrivateMultiPart();

    const [types, setTypes] = useState([]);
    const [measures, setMeasures] = useState([]);
    const [sources, setSources] = useState([]);
    const [aminoAcidDataSources, setAminoAcidDataSources] = useState([]);
    const [brands, setBrands] = useState([]);

    const [brandValue, setBrandValue] = useState(item?.brand ?? { id: 0, name: '' });
    const [brandInputValue, setBrandInputValue] = useState(item?.brand?.name ?? '');
    const [dataSourceValue, setDataSourceValue] = useState(item?.dataSource ?? { id: 0, name: '' });
    const [dataSourceInputValue, setDataSourceInputValue] = useState(item?.dataSource?.id ?? '');
    const [proteinValue, setProteinValue] = useState(item?.protein_grams ?? '');

    const [measureValue, setMeasureValue] = useState(item?.measure ?? { id: 0, name: '' });
    const [measureInputValue, setMeasureInputValue] = useState(item?.measure?.id ?? '');

    const [foodTypeValue, setFoodTypeValue] = useState(item?.foodType ?? { id: 0, name: '' });
    const [foodTypeInputValue, setFoodTypeInputValue] = useState(item?.foodType?.id ?? '');

    const [onlyVisible] = useState(true);
    const [showZero] = useState(true);
    const [showAminoAcidError, setShowAminoAcidError] = useState(false);
    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
    const [isRequired, setIsRequired] = useState(false);

    const [foodAminoAcids, setFoodAminoAcids] = useState([]);
    const [aminoAcidsCount, setAminoAcidsCount] = useState(0);
    const [filteredAminoAcids, setFilteredAminoAcids] = useState(masterAminoAcids);
    const [selectedAminoAcids, setselectedAminoAcids] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState(fileList);
    const [isFilesUploaded, setIsFilesUploaded] = useState(false);

    const getFoodTypes = () => {
        getPortalFoodTypes(axiosPrivate, {}, (response) => {
            if (response.status === 200) {
                setTypes(response.data);
            }
            else {
                setTypes([]);
            }
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getFoodTypes, []);

    const getFoodMeasures = () => {
        getPortalFoodMeasures(axiosPrivate, {}, (response) => {
            if (response.status === 200) {
                setMeasures(response.data);
            }
            else {
                setMeasures([]);
            }
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getFoodMeasures, []);

    const getDataSources = () => {
        getPortalDataSources(axiosPrivate, {}, (response) => {
            if (response.status === 200) {
                setSources(response.data);
            }
            else {
                setSources([]);
            }
        });
    }
    const getAminoAcidDataSources = () => {
        getPortalAminoAcidDataSources(axiosPrivate, {}, (response) => {
            if (response.status === 200) {
                setAminoAcidDataSources(response.data);
            }
            else {
                setAminoAcidDataSources([]);
            }
        });
    }

    const EditAminoAcid = () => {
        if (item) {
            setselectedAminoAcids([]);
            const acidsArray = _defaultValues.aminoAcids.sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            setFoodAminoAcids(acidsArray);
            setAminoAcidsCount(acidsArray.length);
            const value = selectedAminoAcids;
            _defaultValues.aminoAcids.forEach((element, index) => {
                value.push(element.aminoAcidId);
            });
            setselectedAminoAcids(value);
        }
    }

    // if (item) {
    //     item.aminoAcids?.forEach((a, index) => {
    //         methods.setValue(`aminoAcids.${index}.dataSourceId`, a.dataSourceId.toString());
    //     });
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getDataSources, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getAminoAcidDataSources, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(EditAminoAcid, []);

    const getBrands = (value) => {
        if (value) {
            getPortalBrands(axiosPrivate, { startsWith: value }, (response) => {
                if (response.status === 200) {
                    setBrands(response.data);
                }
                else {
                    setBrands([]);
                }
            });
        }
        else {
            setBrands([]);
        }
    }


    const AddFoodSchema = Yup.object().shape({
        id: Yup.number(),
        name: Yup.string().max(200).required('Food Name is required'),
        brandName: Yup.string().max(50).required('Brand Name is required'),
        foodTypeId: Yup.string().required('Type is required'),
        servingSize: Yup.number().positive("Serving Size must be positive").required('Serving Size is required'),
        measureId: Yup.string().required('Measure is required'),
        servingLabel: isRequired ? Yup.string().required('Serving Label is required') : Yup.string(),
        // totalServings: Yup.string().required('Total Serving is required').min(1, "Total Serving must be greater than 0."),
        protein_grams: Yup.number().transform((_, val) => {
            // debugger; // eslint-disable-line no-debugger
            const ret = (val !== null && val !== "") ? Number(val) : undefined
            return ret;
        }).required('Protein is required'),
        calories: Yup.number(),
        notes: Yup.string(),
        proteinEQ_grams: Yup.number(),
        weight_grams: Yup.number(),
        keywords: Yup.string().max(255),
        isActive: Yup.boolean(),
        isPremium: Yup.boolean(),
        isRecipe: Yup.boolean(),
        isSimplifiedTracking: Yup.boolean(),
        isTrending: Yup.boolean(),
        baseHMPFoodId: Yup.number(),
        dataSourceId: Yup.string().nullable().required("DataSource is required"),
        aminoAcids: Yup.array()
            .of(
                Yup.object().shape({
                    aminoAcidId: Yup.number().required("Aminoacid  is required").transform((_, val) => {
                        // debugger; // eslint-disable-line no-debugger
                        const ret = (val !== null && val !== "") ? Number(val) : 0
                        return ret;
                    }),
                    name: Yup.string(),
                    value: Yup.number().required("Aminoacid value is required").transform((_, val) => {
                        const ret = (val !== null && val !== "") ? Number(val) : 0
                        return ret;
                    }),
                    isVerified: Yup.boolean(),
                    dataSourceId: Yup.string().required('Data source is required.').transform((_, val) => {
                        const ret = (val !== null && val !== "" && val !== "0") ? val : ''
                        return ret;
                    }),
                    isFieldUpdated:Yup.boolean(),
                })
            ),
        rankingWeight: Yup.number().min(0, 'Ranking Weight should not be less than zero'),
        labeledProtein_grams: Yup.string().max(5).notRequired().nullable(),
        isBabyFood: Yup.boolean(),
        photos: Yup.array(),
        labDetails: Yup.string().notRequired().nullable(),
        manufacturerIngredients: Yup.string().notRequired().nullable()
    });

    const _defaultValues = {
        id: item?.id ?? 0,
        name: item?.name ?? '',
        brandName: item?.brand?.name ?? '',
        foodTypeId: item?.foodType?.id ?? '',
        measureId: item?.measure?.id ?? '',
        servingSize: item?.servingSize ?? 0,
        servingLabel: item?.servingLabel ?? '',
        totalServings: item?.totalServings ?? 1,
        protein_grams: item?.protein_grams ?? null,
        calories: item?.calories ?? 0,
        notes: item?.notes ?? '',
        proteinEQ_grams: item?.proteinEQ_grams ?? 0,
        weight_grams: item?.weight_grams ?? 0,
        keywords: item?.keywords ?? '',
        isActive: item?.isActive ?? true,
        isPremium: item?.isPremium ?? false,
        isRecipe: item?.isRecipe ?? false,
        isSimplifiedTracking: item?.isSimplifiedTracking ?? false,
        isTrending: item?.isTrending ?? false,
        baseHMPFoodId: item?.baseHMPFoodId ?? 0,
        aminoAcids: item?.aminoAcids?.map((a, index) => {
            const result = {
                id: a.id,
                aminoAcidId: a.aminoAcid.id,
                name: a.aminoAcid.name,
                dataSourceId: a.dataSourceId.toString(),
                value: a.id > 0 ? a.value : 0,
                isVerified: a.id > 0 ? a.isVerified : true,                
                updatedAtPublic: a.id > 0 ? a.updatedAtPublic : new Date(),
                createdAt: a.id > 0 ? a.createdAt : new Date(),
                isFieldUpdated:a.id > 0 ? a.isFieldUpdated : false
            };
            return result;
        }).sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        }) ?? [],
        dataSourceId: item?.dataSource?.id ?? null,
        rankingWeight: item?.rankingWeight ?? 0,
        createdAt: item ? new Date(item.createdAt) : new Date(),
        updatedAt: item ? new Date(item.updatedAt) : new Date(),
        // publicDate: item ? new Date(item.publicDate) : null,
        updatedAtPublic: item ? new Date(item.updatedAtPublic) : new Date(),
        labeledProtein_grams: item ? item.labeledProtein_grams : '',
        isBabyFood: item?.isBabyFood ?? false,
        photos: item?.photos,
        labDetails: item?.labDetails ?? null,
        manufacturerIngredients:item?.manufacturerIngredients ?? null
    };

    const methods = useForm({
        resolver: yupResolver(AddFoodSchema),
        defaultValues: _defaultValues
    });


    const {
        control,
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = methods;

    const { fields, remove, insert } = useFieldArray({
        control,
        name: "aminoAcids",
    });
    /**
     * Recursively converts a nested object into FormData.
     * Handles arrays, nested objects, dates, and files.
     */
    function objectToFormData(obj, form = new FormData(), namespace = "") {
        // ✅ Iterate safely over own keys only
        Object.entries(obj || {}).forEach(([key, value]) => {
            // Skip undefined values
            if (value === undefined) return;

            const formKey = namespace ? `${namespace}.${key}` : key;

            // Handle arrays
            if (Array.isArray(value)) {
                value.forEach((v, i) => {
                    objectToFormData(v, form, `${formKey}[${i}]`);
                });
                return;
            }

            // Handle files
            if (value instanceof File) {
                form.append(formKey, value);
                return;
            }

            // Handle dates
            if (value instanceof Date) {
                form.append(formKey, value.toISOString());
                return;
            }

            // Handle nested objects
            if (value && typeof value === "object") {
                objectToFormData(value, form, formKey);
                return;
            }

            // Primitives (string, number, boolean, null)
            form.append(formKey, value == null ? "" : value);
        });

        return form;
    }


    const handleSave = (request, event) => {
        try {

            setIsSubmitSuccessful(true);
            const newRequest = { ...request, brand: brandValue, aminoAcids: foodAminoAcids, files: uploadedFiles }
            // request.files = uploadedFiles;
            console.log(newRequest);
            const formData = objectToFormData(newRequest);
            formData.append('isFilesUploaded', isFilesUploaded);

            if (uploadedFiles && uploadedFiles.length > 0) {
                uploadedFiles.forEach(element => {
                    formData.append('files', element);
                });
            }

            if (request.id > 0) {
                // updateFood(newRequest);
                updateFood(formData, request.id);
            }
            else {
                addFood(formData);
            }
            setIsSubmitSuccessful(false);
        } catch (error) {
            setIsSubmitSuccessful(false);
        }
        return true;
    }

    const addFood = (request) => {
        onPortalAddFoodV2(axiosPrivate, request, (response) => {
            if (response.status === 201) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const updateFood = (request, id) => {
        onPortalUpdateFoodV2(axiosPrivate, request, id, (response) => {
            if (response.status === 200) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const AddAminoAcid = () => {
        const acidsArray = foodAminoAcids;
        if (foodAminoAcids.length === masterAminoAcids.length) {
            return;
        }
        const element = masterAminoAcids[acidsArray.length];
        const result = { aminoAcidId: null, name: element.name, value: element.value, dataSourceId: element.dataSourceId, isChecked: false,isFieldUpdated:true }
        acidsArray.push(result);
        setFoodAminoAcids(acidsArray);
        setAminoAcidsCount(aminoAcidsCount + 1);
        insert(acidsArray.length);
    }
    const DeleteAminoAcid = (id, index) => {
        const acidsArray = foodAminoAcids;
        const deletedAminoAcidId = Number(fields.filter(x => x.id === id)[0].aminoAcidId);
        if (foodAminoAcids.length === 0 || aminoAcidsCount === 0) {
            return;
        }

        acidsArray.splice(fields.findIndex(x => x.id === id), 1);
        setFoodAminoAcids(acidsArray);
        setAminoAcidsCount(acidsArray.length);
        const value = selectedAminoAcids.filter(x => x !== deletedAminoAcidId);
        setselectedAminoAcids(value);
        remove(index);
    }

    const UpdateDate = (request) => {
        onPortalUpdateFoodDate(axiosPrivate, request, (response) => {
            if (response.status === 200) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const handleFilesChange = (files) => {
        console.log("Selected files:", files);
        setUploadedFiles(files);
        setIsFilesUploaded(true);
    };

    const icon = (name, color) => (
        <SvgColor src={`/assets/icons/setting/${name}.svg`} sx={{ width: 1, height: 1, color }} />
    );

    const icon_Btn = (name, color) => (
        <SvgColor src={`/assets/icons/setting/${name}.svg`} sx={{ width: 1, height: 1, color }} />
    );

    const renderAminoAcids = () =>
        <>
            <Grid container item xs={12} spacing={1}>
                <Grid item xs={0}>
                    <Paper style={classes.paper}>
                        <Typography variant="h6" xs={12}>Amino Acids</Typography>
                    </Paper>
                </Grid>
                {
                    showAminoAcidError ?
                        <Grid item xs={12}>
                            <Paper style={classes.root}>
                                <Alert severity="error">Please mark checkbox to auto calculate aminoAcid values !</Alert>
                            </Paper>
                        </Grid>
                        : null
                }
            </Grid>
            {

                <Grid item xs={12} >
                    {readOnly !== true ?
                        <Paper style={classes.aminoAcidIdBtn}>
                            <Button variant="outlined" onClick={AddAminoAcid}>Add AminoAcids
                                &nbsp;&nbsp; <StyledIcon style={{ marginRight: 0 }}>{icon('ic_Add', 'black')}</StyledIcon></Button>
                        </Paper> : null
                    }

                    {/* {JSON.stringify(fields)} */}
                    {aminoAcidsCount > 0 && fields.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    }).map((element, index) =>
                        <Grid id={`container-${element.id}`} key={`container-${index}`} container item xs={12} spacing={0}>                            
                            <Grid item xs={3} key={`${index}-aminoAcidId`} className={classes.aminoAcidDropdown} style={{maxWidth:'15%'}}>
                                <Paper style={classes.paper} key={`${index}-Paper-aminoAcidId`} >
                                    <RHFSelect name={`aminoAcids.${index}.aminoAcidId`} label="Amino Acid *" title='Amino Acid' readOnly={readOnly}
                                        disabled={readOnly}
                                        key={element.id}                                        
                                        SelectProps={{
                                            renderValue: (selected) => {
                                                const selectedAcid = filteredAminoAcids.find(
                                                    (d) => d.id?.toString() === selected?.toString()
                                                );
                                                const label = selectedAcid?.name ?? '';
                                                const displayLabel = label.length > 20 ? `${label.slice(0, 20)}...` : label;
                                                return (
                                                    <Tooltip title={label} arrow>
                                                        <span style={{ display: 'block', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {displayLabel}
                                                        </span>
                                                    </Tooltip>
                                                );
                                            },
                                        }}
                                        onChange={(event, newValue) => {
                                            element.aminoAcidId = newValue.props.value.toString();
                                            methods.setValue(`aminoAcids.${index}.aminoAcidId`, newValue.props.value.toString());
                                            methods.setValue(`aminoAcids.${index}.isFieldUpdated`, true);
                                            const value = selectedAminoAcids;
                                            value.push(newValue.props.value);
                                            setselectedAminoAcids(value);
                                            setFoodAminoAcids(foodAminoAcids.map((x, i) => {
                                                if (i === index) {
                                                    return { ...x, aminoAcidId: newValue.props.value,isFieldUpdated:true }
                                                }
                                                return x;
                                            }));
                                        }}
                                    >
                                        {
                                            filteredAminoAcids.map((dataSourcevalue, dataSourceIndex) =>
                                                <MenuItem disabled={selectedAminoAcids.includes(dataSourcevalue.id)} key={dataSourceIndex}
                                                    value={dataSourcevalue.id} selected={dataSourcevalue.id === element.aminoAcidId}>{dataSourcevalue.name}</MenuItem>
                                            )
                                        }

                                    </RHFSelect>
                                </Paper>
                            </Grid>
                            <GridPaperonChange name={`aminoAcids.${index}.value`} label='mg *' type="number" xs={1.5} title='Amino Acid Value'
                                readOnly={readOnly} key={element.id} value={element.value} disabled={readOnly}
                                onChange={(event, newValue) => {
                                    methods.setValue(`aminoAcids.${index}.value`, Number(event.target.value));
                                    methods.setValue(`aminoAcids.${index}.isFieldUpdated`, true);
                                    element.value = Number(event.target.value);
                                    setFoodAminoAcids(foodAminoAcids.map((x, i) => {
                                        if (i === index) {
                                            return { ...x, value: element.value ,isFieldUpdated:true}
                                        }
                                        return x;
                                    }));
                                }}
                                showZero={showZero}
                            />
                            <Grid item xs={3} key={`${index}-dataSourceId`}>
                                <Paper style={classes.paper} key={`${index}-Paper-dataSourceId`}>
                                    <RHFSelect name={`aminoAcids.${index}.dataSourceId`} label="Data Source *" title='Data Source'
                                        value={element.dataSourceId ?? ''} key={element.id} readOnly={readOnly} disabled={readOnly}
                                        SelectProps={{
                                            renderValue: (selected) => {
                                                const selectedSource = aminoAcidDataSources.find(
                                                    (d) => d.id?.toString() === selected?.toString()
                                                );
                                                const label = selectedSource?.name ?? '';
                                                const displayLabel = label.length > 20 ? `${label.slice(0, 20)}...` : label;
                                                return (
                                                    <Tooltip title={label} arrow>
                                                        <span style={{ display: 'block', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {displayLabel}
                                                        </span>
                                                    </Tooltip>
                                                );
                                            },
                                        }}
                                        onChange={(event, newValue) => {
                                            methods.setValue(`aminoAcids.${index}.dataSourceId`, newValue.props.value.toString());
                                            methods.setValue(`aminoAcids.${index}.isFieldUpdated`, true);
                                            element.dataSourceId = newValue.props.value.toString();
                                            setFoodAminoAcids(foodAminoAcids.map((x, i) => {
                                                if (i === index) {
                                                    return { ...x, dataSourceId: newValue.props.value,isFieldUpdated:true }
                                                }
                                                return x;
                                            }));
                                        }}
                                    >
                                        {
                                            aminoAcidDataSources.map((dataSourcevalue, dataSourceIndex) =>
                                                <MenuItem key={dataSourceIndex} value={dataSourcevalue.id} selected={dataSourcevalue.id === element.dataSourceId}>{dataSourcevalue.name}</MenuItem>
                                            )}
                                    </RHFSelect>
                                </Paper>
                            </Grid>
                            {/* <Grid item key={`${index}-isVerified`} xs={1}>
                                <Paper style={classes.paper} key={`${index}-Paper-isVerified`}>
                                    <RHFCheckboxWithLabel name={`aminoAcids.${index}.isVerified`} key={element.id} checked={element.isVerified} title='IsVerfied' readOnly={readOnly} disabled={readOnly}
                                        onChange={(event) => {
                                            methods.setValue(`aminoAcids.${index}.isVerified`, event.target.checked);
                                            element.isVerified = event.target.checked;
                                            setFoodAminoAcids(foodAminoAcids.map((x, i) => {
                                                if (i === index) {
                                                    return { ...x, isVerified: event.target.checked }
                                                }
                                                return x;
                                            }));
                                        }} />
                                </Paper>
                            </Grid> */}
                            {item ?
                                <>                                    
                                    <Grid item xs={2}>                                        
                                        <GridPaperDate name={`aminoAcids.${index}.updatedAtPublic`} label='Public Date' value={element.updatedAtPublic} xs={10} readOnly={_readonly} />
                                    </Grid>
                                </>
                                : <>
                                    {/* <GridPaperDate name="createdAt" label='Created Date' xs={2.20} value={new Date()} readOnly={_readonly} disabled={disabled} />
                                    <GridPaperDate name="updatedAt" label='Updated Date' xs={2.20} value={new Date()} readOnly={_readonly} disabled={disabled} /> */}
                                </>
                            }
                            {
                                readOnly !== true ?
                                    <Grid item xs={0.5} key={`${index}-delete`} style={{ paddingTop: '10px',position:'relative',left: '-70px',top:'2px' }}>
                                        <RHFCheckboxWithLabel helperText="" name={`aminoAcids.${index}.isUpdateDate`} title='Mark checkbox to update date!' readOnly={readOnly} disabled={readOnly}
                                            onChange={(event) => {
                                                methods.setValue(`aminoAcids.${index}.isUpdateDate`, event.target.checked);
                                                setFoodAminoAcids(foodAminoAcids.map((x, i) => {
                                                    if (i === index) {
                                                        return { ...x, isUpdateDate: event.target.checked }
                                                    }
                                                    return x;
                                                }));
                                            }}
                                        />
                                    </Grid> : null
                            }
                        </Grid>

                    )}
                </Grid>
            }
        </>

    return (
        <>
            <Helmet>
                <title>View Food | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'} spacing={{ xs: 0.5, sm: 1.5 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(handleSave)}>
                    <div style={classes.root}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={10}>
                                <Typography variant="h4" component="h4" paragraph>
                                    {readOnly ? 'View Food' : `${item ? 'Update' : 'Add'} Food`}
                                </Typography>
                                {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                            </Grid>
                            <Grid item xs={2} style={{ paddingLeft: '4%' }}>
                                {item && <>
                                    <Typography variant="h6" component="h6" paragraph>
                                        #{item.id}
                                    </Typography>
                                </>}

                                {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                            </Grid>
                            {
                                item ? <Grid item xs={12}>
                                    <GridPaper name="baseHMPFoodId" label='HMPFoodId' xs={2} readOnly={_readonly} />
                                </Grid> : null
                            }

                            <GridPaper name="name" label='Name *' xs={12} readOnly={readOnly} />
                            <Grid item xs={6}>
                                <Paper style={classes.paper}>
                                    <RHFAutocomplete
                                        name="brandName"
                                        label="Brand *"
                                        readOnly={readOnly}
                                        value={brandValue}
                                        onChange={(event, newValue) => {
                                            setBrandValue('');
                                            setBrandInputValue('');
                                            setValue('brandName', '', { shouldValidate: true });

                                            if (newValue) {
                                                setBrandValue(newValue);
                                                setBrandInputValue(newValue.name ?? '');
                                                setValue('brandName', newValue.name, { shouldValidate: true });
                                            }

                                        }}
                                        inputValue={brandInputValue}
                                        onInputChange={(event, value) => {
                                            setBrandInputValue(value ?? '');
                                            setBrandValue({ id: 0, name: value });
                                            setValue('brandName', value, { shouldValidate: true });
                                            getBrands(value);
                                        }}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        options={brands}
                                        freeSolo
                                    />
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper style={classes.paper}>
                                    <RHFAutocomplete
                                        name="foodTypeId"
                                        label="Type *"
                                        readOnly={readOnly}
                                        autoSelect
                                        value={foodTypeValue}
                                        onChange={(event, newValue) => {
                                            setFoodTypeValue('');
                                            setFoodTypeInputValue('');
                                            setValue('foodTypeId', '', { shouldValidate: true });
                                            if (newValue) {
                                                setFoodTypeValue(newValue);
                                                setFoodTypeInputValue(newValue.name ?? '');
                                                setValue('foodTypeId', parseInt(newValue.id, 10), { shouldValidate: true });
                                            }

                                        }}
                                        inputValue={foodTypeInputValue}
                                        onInputChange={(event, value) => {
                                            if (value) {
                                                setFoodTypeValue(value);
                                                setFoodTypeInputValue(value ?? '');
                                            }
                                        }}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        options={types}
                                    />
                                </Paper>
                            </Grid>
                            <GridPaper name="servingLabel" label='Serving Label' readOnly={readOnly} xs={3} />
                            <GridPaper name="servingSize" label='Serving *' type="number" readOnly={readOnly} xs={3} />
                            <Grid item xs={3}>
                                <Paper style={classes.paper}>
                                    <RHFAutocomplete
                                        autoSelect
                                        name="measureId"
                                        label="Measure *"
                                        readOnly={readOnly}
                                        value={measureValue}
                                        onChange={(event, newValue) => {
                                            setIsRequired(false);
                                            if (!newValue) {
                                                setMeasureValue('');
                                                setMeasureInputValue('');
                                                setValue('measureId', '', { shouldValidate: true });
                                            }
                                            else if(newValue.id === 2) {
                                                setIsRequired(true);
                                            }
                                            setMeasureValue('');
                                            setMeasureInputValue('');
                                            setValue('measureId', '', { shouldValidate: true });
                                            if (newValue) {
                                                setMeasureValue(newValue);
                                                setMeasureInputValue(newValue.name ?? '');
                                                setValue('measureId', parseInt(newValue.id, 10), { shouldValidate: true });
                                            }
                                            else {
                                                setMeasureValue('');
                                                setMeasureInputValue('');
                                                setValue('measureId', '', { shouldValidate: true });
                                            }

                                        }}
                                        inputValue={measureInputValue}
                                        onInputChange={(event, value) => {
                                            if (value) {
                                                setMeasureValue(value);
                                                setMeasureInputValue(value ?? '');
                                            }
                                        }}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        options={measures}
                                    />
                                </Paper>
                            </Grid>
                            <GridPaper name="weight_grams" label='Weight (g)' type="number" readOnly={readOnly} xs={3} />
                            {/* <GridPaper name="totalServings" label='Total Servings' type="number" readOnly={readOnly} /> */}
                            <GridPaper name="protein_grams" label='Protein (g) *' type="number" readOnly={readOnly} showZero={showZero} xs={3} />
                            <GridPaper name="proteinEQ_grams" label='ProteinEQ (g)' type="number" readOnly={readOnly} xs={3} />
                            <GridPaper name="calories" label='Calories' type="number" readOnly={readOnly} xs={3} />
                            <GridPaper name="labeledProtein_grams" label='Labeled Protein' xs={3} readOnly={readOnly} validatemaxLength={validateMaxLength} maxLength={8} />                            
                            <Grid item xs={4}>
                                <Paper style={classes.paper}>
                                    <RHFAutocomplete
                                        autoSelect
                                        name="dataSourceId"
                                        label="Data Source *"
                                        readOnly={readOnly}
                                        value={dataSourceValue}
                                        onChange={(event, newValue) => {
                                            setDataSourceValue('');
                                            setDataSourceInputValue('');
                                            setValue('dataSourceId', '', { shouldValidate: true });
                                            if (newValue) {
                                                setDataSourceValue(newValue);
                                                setDataSourceInputValue(newValue.name ?? '');
                                                setValue('dataSourceId', parseInt(newValue.id, 10), { shouldValidate: true });
                                            }

                                        }}
                                        inputValue={dataSourceInputValue}
                                        onInputChange={(event, value) => {
                                            if (value) {
                                                setDataSourceValue(value);
                                                setDataSourceInputValue(value ?? '');
                                            }
                                        }}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        options={sources}
                                    />
                                </Paper>
                            </Grid>
                            {
                                item ?
                                    <>
                                        {/* <Grid item xs={4}>
                                            <GridPaperDate name="createdAt" label='Created Date' xs={10} value={item.createdAt} readOnly={_readonly} />
                                        </Grid> */}
                                        {/* <Grid item xs={1.7}>
                                            <GridPaperDate name="publicDate" label='Public Date' xs={12} value={item.publicDate} readOnly={_readonly} style={{ float: 'left' }} />
                                        </Grid> */}
                                        <Grid item xs={1.7}>
                                            <GridPaperDate name="updatedAtPublic" label='Public Date' xs={12} value={item.updatedAtPublic} readOnly={_readonly} style={{ float: 'left' }} />
                                        </Grid>
                                        <Grid item xs={1} style={{ paddingTop: '16px',position:'relative',left: '-40px',top:'5px' }}>
                                            <RHFCheckboxWithLabel name="isUpdateDate" title='Mark checkbox to update date!' readOnly={readOnly} disabled={readOnly}
                                                onChange={(event) => {
                                                    setValue(`isUpdateDate`, event.target.checked);
                                                }}
                                            />
                                        </Grid>
                                        <GridPaper name="keywords" label='Keywords' xs={12} readOnly={readOnly} />
                                    </>
                                    : <>                                        
                                        <GridPaper name="keywords" label='Keywords' xs={8} readOnly={readOnly} />
                                    </>
                            }

                            <GridPaper name="notes" label='Notes' xs={12} readOnly={readOnly} />
                            <GridPaper name="labDetails" label='Lab Details' xs={12} readOnly={readOnly} />
                            <GridPaper name="manufacturerIngredients" label='Manufacturer Ingredients' xs={12} readOnly={readOnly} />
                            <Grid item xs={4}>
                                <GridPaper name="rankingWeight" label='Ranking Weight' type="number" showZero={showZero} readOnly={readOnly} xs={12} />
                            </Grid>
                            <Grid item xs={8}>
                                <Paper style={{ padding: 5 }}>
                                    <RHFFileUploadField xs={6} name="files" label='Upload' readOnly={readOnly}
                                        multiple onFilesChange={handleFilesChange} values={uploadedFiles} />
                                </Paper>
                            </Grid>                            
                            <GridPaperSwitch name="isActive" label='Is Active' xs={2} readOnly={readOnly} style={{ maxWidth: '20%' }} />
                            <GridPaperSwitch name="isRecipe" label='Is Recipe' xs={2} readOnly={readOnly} style={{ maxWidth: '20%' }} />                            
                            <GridPaperSwitch name="isSimplifiedTracking" label='Is Simplified' xs={3} readOnly={readOnly} style={{ maxWidth: '20%' }} />
                            <GridPaperSwitch name="isTrending" label='Is Trending' xs={3} readOnly={readOnly} style={{ maxWidth: '20%' }} />
                            <GridPaperSwitch name="isBabyFood" label='Is BabyFood' xs={3} readOnly={readOnly} style={{ maxWidth: '20%' }} />
                            {renderAminoAcids()}
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={2}>
                                    <Paper style={classes.paper}>
                                        {!readOnly &&
                                            <LoadingButton
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitSuccessful || isSubmitting}
                                            >
                                                {item ? "Update" : "Add"}
                                            </LoadingButton>
                                        }
                                    </Paper>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </div>
                </FormProvider>
            </Container>
        </>
    )
}

export default FoodView;